import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MudarFocoService {
  public mudarFoco$: BehaviorSubject<boolean> = new BehaviorSubject(false);
}
